<template>
    <ion-row class="mt-2">
        <ion-col class="fs-smaller fs-12 grey1-grey1-color">
            {{ $t(`alert.selectSupplier`) }}
        </ion-col>
    </ion-row>

    <ion-row class="supplier-name-bold mb-2">
        <ion-col>
            <select-simple
                :model-value="selectedSupplierId" @change="changeSupplierId"
                class="grey4-grey4-background inherit-background purple-purple-color max-width chevron-select unset-max-width"
                :placeholder="$t('messages.setting.delivererSelect')"
                :options="(audience as unknown as { [key: string]: unknown }[])"
                valueKey="id" textKey="name"
                :disabled="audience.length < 1" />
        </ion-col>
    </ion-row>

    <ion-row>
        <ion-col v-if="availableProducts.length">
            <div v-for="product in availableProducts" :key="product.id" class="item-container">
                <div>{{ product.item.name }} {{ product.item.variants.name }}</div>
                <input-amount-performance-new-web
                    style="transform: scale(0.9); margin: 0;"
                    v-model="products[product.id]"
                    @change="products[product.id] = $event;"
                    :amount-step="product.stepAmount"
                    :max="product.limitOrderSize"
                />
            </div>
        </ion-col>

        <ion-col v-else>
            {{ $t('messages.noEntries') }}
        </ion-col>
    </ion-row>

    <ion-row v-if="availableProducts.length">
        <ion-col class="center">
            <button-base
                :color="ION_VARIANT.CORAL"
                class="ml-3 mr-3 fw-b wrap-button tt-none max-width"
                @click="$emit('addPackage', { products, supplierId: selectedSupplierId})"
                :disabled="Object.values(products).reduce((a, v) => a + v, 0) < Number(information.config?.packageSize)"
            >
                {{ $t(`modal.addCart`) }}
            </button-base>
        </ion-col>
    </ion-row>
</template>

<script setup lang="ts">
import { IonCol, IonRow } from "@ionic/vue";
import { computed, ref, watch } from "vue";

import ButtonBase from "@/components/button/ButtonBase.vue";
import SelectSimple from "@/components/selects/SelectSimple.vue";
import InputAmountPerformanceNewWeb from "@/components/input/InputAmountPerformanceNewWeb.vue";

import { ION_VARIANT } from "@/types/enum/ionicEnum";
import { FlexibleProductInterfaceProps } from "@/types/props/component";
import { FlexibleProductInterfaceEmits } from "@/types/emits/component";

const props = defineProps<FlexibleProductInterfaceProps>()
const emit = defineEmits<FlexibleProductInterfaceEmits>()

const products = ref<Record<string, number>>({})
const selectedSupplierId = ref<string>(props.audience[0].id)

const availableProducts = computed(() => {
    const matchedProducts = []
    for (const product of props.information.products) {
        if (product.availableBy?.length && product.availableBy.includes(selectedSupplierId.value)) matchedProducts.push(product)
    }
    // if (!matchedProducts.length) return props.information.products // If non-harmonised products are allowed
    return matchedProducts
})

const changeSupplierId = (supplierId: unknown) => {
    if (typeof supplierId === "string") selectedSupplierId.value = supplierId
}

watch(selectedSupplierId, () => products.value = {}) // reset values if supplier change
</script>

<style scoped>
.item-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-radius: 0.5rem;
    padding-left: 0.5rem;
    margin: 0.25rem 0;
    border: 1px solid var(--ion-color-grey3);
    /*box-shadow: 0 2px 2px 0 var(--light-shadow);*/
    background-color: white;
    background: linear-gradient(0deg, #e5e5e5, #fff);
}

@media (min-width: 500px) and (min-height: 500px) {
    .unset-max-width {
		max-width: unset;
	}
}

@media (orientation: landscape) and (min-height: 500px) {
    .unset-max-width {
		max-width: unset;
	}
}
</style>

<style>
.supplier-name-bold ion-select::part(text) {
    font-weight: bold;
}
</style>
